var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocServices = function SvgDocServices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 42,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#717888",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M27.846 9.168H3.91A2.91 2.91 0 0 0 1 12.078V38.09A2.91 2.91 0 0 0 3.91 41h23.936a2.91 2.91 0 0 0 2.91-2.91V12.078a2.91 2.91 0 0 0-2.91-2.91M21.115 23.794h-8.02M26.58 19.619H13.094M21.115 34.016h-8.02M26.58 29.841H13.094"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#717888",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.653 18.784h-4.2a.835.835 0 0 0-.835.835v4.2c0 .461.374.835.835.835h4.2a.835.835 0 0 0 .835-.835v-4.2a.835.835 0 0 0-.835-.835M9.653 28.98h-4.2a.835.835 0 0 0-.835.836v4.2c0 .461.374.835.835.835h4.2a.835.835 0 0 0 .835-.835v-4.2a.835.835 0 0 0-.835-.835M3.555 9.168l20.217-7.996c1.62-.632 3.365.557 3.365 2.277v5.72z"
  })));
};
export default SvgDocServices;